/** @format */

const germanyVariant = [
  {
    property: "partner.variant",
    value: "germany",
  },
];

const bankLoginVariant = [
  {
    property: "partner.variant",
    value: "bank-login",
  },
];

const showSuccessVerificationScreen = [
  {
    property: "app.sofortDataChanged",
    value: false,
    conditions: germanyVariant,
  },
  {
    property: "sofortIdent.agecheck_result",
    value: "valid",
    conditions: germanyVariant,
  },
  {
    property: "bankNameCheck.result",
    value: "valid",
    conditions: bankLoginVariant,
  },
  {
    property: "identIdAdressCheck.result",
    value: "valid",
    conditions: bankLoginVariant,
  },
];

module.exports = {
  showSuccessVerificationScreen,
};



// WEBPACK FOOTER //
// ./src/subflows/conditions.js